import * as React from "react";
import { Attachment, AttachmentStore } from "Stores/attachmentStore";
import { inject, observer } from "mobx-react";
import { Spinner } from "react-bootstrap";


interface AttachmentLinkProps {
    attachmentStore?: AttachmentStore
    attachment: Attachment
    includeIcon: boolean
    // associatedObjectId is the id of the object the Attachment is associated with (i.e. ActionPlan or Comment)
    //  Currently, this is only needed by the CommentList component
    associatedObjectId?: string
    onDelete?: (att: Attachment, ownerId: string) => void
}

@inject("attachmentStore")
@observer
export class AttachmentLink extends React.Component<AttachmentLinkProps> {
    handleClick = (ev) => {
        ev.preventDefault();
        this.props.attachmentStore!.downloadAttachment(this.props.attachment.id);
    };

    handleDeleteClick = (ev) => {
        ev.stopPropagation();
        this.props.onDelete!(this.props.attachment, this.props.associatedObjectId!);
        return false;
    };

    renderAttachmentIcon = () => {
        const iconClass = this.props.attachment.file_icon === "file" ? "icon-file-o" : `icon-file-${this.props.attachment.file_icon}-o`;
        return <i className={`file-icon icon ${iconClass}`} />;
    };

    render() {
        if(this.props.attachment.status === "pending"){
            return (
                <span className="attachment-link pending" title="Your attachment is being processed">
                    <i className="icon icon-hourglass-o"/>
                    {this.props.attachment.file_name}
                 </span>
            );
        }
        return (
            <span className={`attachment-link${this.props.onDelete ? " editing" : ""}`} onClick={this.props.onDelete ? undefined : this.handleClick}>
                {this.props.includeIcon && !this.props.onDelete ? this.renderAttachmentIcon() : null}
                {this.props.attachmentStore!.isDownloadingAttachment === this.props.attachment.id
                    ? <Spinner animation="border" size="sm"/>
                    : this.props.attachment.file_name}
                {this.props.onDelete && this.props.attachment.permissions.can_delete
                    ? <i onClick={this.handleDeleteClick} className="icon icon-times"/>
                    : null}
            </span>
        );
    }
}